module.exports = __webpack_public_path__ + "img/Inflammation-OVCA_10X_TPCP.98c44d54.png";